<template>
  <img class="absolute z-0 left-0 top-0 right-0 w-full h-[844px] md:h-[1080px] object-fill" src="@/assets/images/background.webp" />
  <div class="absolute z-[100] left-1/2 right-1/2 top-[calc(844px-75px)] md:top-[calc(1080px-135px)] flex flex-row p-2.5 gap-2.5 items-center cursor-pointer" @click="scrollDown">
    <span class="text-red-600">{{ t('home.hero.explore') }}</span>
    <ArrowDown class="shrink-0 w-[31px]" />
  </div>
  <div class="z-10 w-full h-[calc(844px-124px)] md:h-[calc(1080px-138px)] pl-16 pr-[175px] flex flex-row">
    <div class="flex-grow pt-[148px]">
      <MultilangHtml is="h1" class="text-4xl md:ext-6xl font-semibold uppercase" :html="t('home.hero.title')" />
      <p class="mt-6 mb-[72px] text-md md:text-3xl text-neutral-500">{{ t('home.hero.text') }}</p>
      <VaButton round class="h-[68px] !pl-5 !pr-3" :to="{ name: 'appointment' }">
        <span class="font-normal">{{ t('common.bookDemo') }}</span>
        <ArrowRight class="ml-8 w-4 m-2" />
      </VaButton>
    </div>
    <div class="hidden md:block shrink-0 w-[707px] h-[707px]">
      <img src="@/assets/images/hero-image.webp" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { VaButton } from 'vuestic-ui'
import { useI18n } from 'vue-i18n'
import MultilangHtml from '@/components/MultilangHtml.vue'
import ArrowDown from '@/assets/icons/arrow-down.svg'
import ArrowRight from '@/assets/icons/arrow-right.svg'

const { t } = useI18n()

const scrollDown = () => {
  const el = document.querySelector('.advantages-segment')
  if (!el) return
  el.scrollIntoView({
    behavior: 'smooth',
  })
}
</script>
